import axios from './axiosInstances/axiosInstance';

export const submitCustomerArrivalNotification = (orderId, message) => {
  return axios.post(`/orders/${orderId}/arrival`, {
    ...(message && {
      message: message,
    }),
  });
};
